import {Component, Input, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {FormType} from '../form-type';

@Component({
    selector: 'tw-form-container',
    templateUrl: './form-container.component.html',
    styleUrls: ['./form-container.component.css'],
    standalone: true
})
export class FormContainerComponent implements OnInit {
    @Input() formGroup: UntypedFormGroup;
    @Input() data: FormType;

    constructor(protected fb: UntypedFormBuilder) {
        this.formGroup.addControl(this.data.name, this.fb.control('', Validators.required));
    }

    ngOnInit() {
    }

}
